import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "common-trash",
  "use": "common-trash-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"common-trash\"><path d=\"M4.00017 12.6667C4.00017 13.4001 4.60017 14.0001 5.33351 14.0001H10.6669C11.4002 14.0001 12.0002 13.4001 12.0002 12.6667V4.66668H4.00017V12.6667ZM12.6669 2.66667H10.3335L9.66687 2H6.33351L5.66684 2.66667H3.3335V4.00001H12.6669V2.66667Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol